import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollWindowToTop() {
  try {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  } catch (_) {
    window.scrollTo(0, 0);
  }
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}

/**
 * Always open freshly selected routes at the top of the page.
 * Covers HashRouter + browser scroll restoration + delayed layout.
 */
function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    scrollWindowToTop();
  }, [pathname, search, key]);

  useEffect(() => {
    scrollWindowToTop();

    const frame1 = requestAnimationFrame(() => {
      scrollWindowToTop();
      requestAnimationFrame(scrollWindowToTop);
    });

    // Beat late images/layout that can restore previous scroll
    const t1 = setTimeout(scrollWindowToTop, 0);
    const t2 = setTimeout(scrollWindowToTop, 50);
    const t3 = setTimeout(scrollWindowToTop, 150);

    // If URL has a section hash on the *new* page, jump there after reset
    let hashTimer;
    if (hash && hash.length > 1) {
      hashTimer = setTimeout(() => {
        const id = decodeURIComponent(hash.slice(1));
        const el =
          document.getElementById(id) ||
          document.querySelector(`[name="${id}"]`);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
        } else {
          scrollWindowToTop();
        }
      }, 200);
    }

    return () => {
      cancelAnimationFrame(frame1);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      if (hashTimer) clearTimeout(hashTimer);
    };
  }, [pathname, search, hash, key]);

  return null;
}

export default ScrollToTop;
